import type { OnboardingProgressPhase } from '../model/progress';

import { StepProgress, type Step } from '@/shared/ui/primitives';

// Order must mirror the backend IDP state machine: per DoseSpot's V2 workflow,
// legal agreements (AgreementId 1 / 6) are presented and accepted *before* the
// IDP disclaimer. Keeping this array in execution order is what makes the
// progress bar monotonic — see `progressPhaseFor` in `model/progress.ts` for
// the step-kind → phase mapping.
const ONBOARDING_STEPS: Array<Step<OnboardingProgressPhase>> = [
  { id: 'profile', label: 'Profile' },
  { id: 'details', label: 'Details' },
  { id: 'legal', label: 'Legal' },
  { id: 'disclaimer', label: 'Disclaimer' },
  { id: 'demographics', label: 'Info' },
  { id: 'verify', label: 'Verify' },
  { id: 'code', label: 'Code' },
  { id: 'bank', label: 'Bank' },
];

export interface OnboardingProgressProps {
  currentPhase: OnboardingProgressPhase;
  className?: string;
}

export function OnboardingProgress({ currentPhase, className }: OnboardingProgressProps) {
  return (
    <StepProgress
      steps={ONBOARDING_STEPS}
      currentStepId={currentPhase}
      showLabels={false}
      className={className}
    />
  );
}
